import styled from "styled-components";

const StyledDialog = styled.div`
  min-width: 50%;
  min-height: 30%;
  display: flex;
  align-items: center;
`;

export default StyledDialog;
